import React from "react";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { CheckIcon } from "@icons";
import styles from "./SidePanel.module.scss";

interface Props {
    children: React.ReactNode;
    onConfirm: () => void;
}

export const SuggestedLineCell: React.FC<Props> = ({ children, onConfirm }) => (
    <div className={styles.suggestedCustomerRow}>
        <div className={styles.suggestedAccount}>{children}</div>
        <Tooltip content="Confirm suggestion">
            <Button
                type="button"
                variant="accent"
                size="md"
                iconOnly
                aria-label="Confirm suggestion"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                    event.stopPropagation();
                    onConfirm();
                }}
            >
                <CheckIcon />
            </Button>
        </Tooltip>
    </div>
);
